'use client';

import {searchParamsFromProductConfiguration} from '@/modules/commerce/product/configuration';

import type {ProductFilters} from '../../filters/query';
import ProductCardBase from '../ProductCardBase';
import {PRODUCT_PAGE_ALL_SLUG} from '../schema/constants';

import {
	getCabTableConfigurationAppropriateForFilters,
	getConfiguredCabTableProductBrands,
} from './filtering';
import type {CabTableProductFragment} from './query';

export type CabTableProductCardProps = {
	product: CabTableProductFragment;
	headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
	filters?: ProductFilters;
};

export default function CabTableProductCard({
	product,
	headingLevel = 2,
	filters,
}: CabTableProductCardProps) {
	const configuration = getCabTableConfigurationAppropriateForFilters(product, filters);
	const params = searchParamsFromProductConfiguration(configuration);

	const brands = getConfiguredCabTableProductBrands(product, configuration);
	const href = `/${PRODUCT_PAGE_ALL_SLUG}/${product.fullSlug}?${params.toString()}`;

	return (
		<ProductCardBase
			href={href}
			product={product}
			configuration={configuration}
			headingLevel={headingLevel}
			brands={brands}
			isConfigurable
		/>
	);
}
